import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });

$w.onReady(function () {
	//TODO: write your page related code here...

});

async function fireEvent(button) {
	const biEventObject = {
		evid: 703,
		button_name: button,
		is_valid: true,
		topic: 'wix partners site',
		url: wixLocation.url
	};
	await biLogger.log(biEventObject);
}

export async function startNow_click(event) {
	await fireEvent('start now')
}


export async function bookAdemoHeader_click(event) {
	await fireEvent('book a demo')
}

export async function bookAdemoOptimize_click(event) {
	await fireEvent('book a demo')
}